import { Link } from "react-router-dom";
import siteConfig from "../../config/site";
import Footer from "../../Components/Footer/Footer";

const ServiceCard = ({ service, featured }) => (
  <div className={`p-6 sm:p-8 rounded-2xl bg-gray-900/60 border transition-all duration-300 group ${
    featured ? "border-gold/40 ring-1 ring-gold/20" : "border-purple-900/30 hover:border-purple-600/40"
  }`}>
    <div className="text-4xl mb-4">{service.icon}</div>
    <h3 className="text-xl font-bold text-white mb-3 group-hover:text-gold transition-colors">
      {service.name}
    </h3>
    <p className="text-gray-400 text-sm leading-relaxed mb-4">
      {service.description}
    </p>
    <div className="border-t border-gray-800/50 pt-4">
      <p className="text-gold font-bold text-lg">{service.price}</p>
    </div>
  </div>
);

const Services = () => {
  const { services } = siteConfig;

  return (
    <div className="bg-[#0a0a0f] min-h-screen">
      {/* Header */}
      <div className="pt-32 pb-16 px-6">
        <div className="max-w-5xl mx-auto text-center">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-4">
            Services & Packages
          </h1>
          <div className="w-24 h-0.5 bg-gradient-to-r from-purple-700 to-gold mx-auto mb-6" />
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Premium private entertainment experiences tailored to your occasion. 
            All services available within Calgary city limits.
          </p>
        </div>
      </div>

      {/* Services Grid */}
      <section className="px-6 pb-16">
        <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, idx) => (
            <ServiceCard key={idx} service={service} featured={idx === 0} />
          ))}
        </div>
      </section>

      {/* Important Notes */}
      <section className="px-6 pb-16">
        <div className="max-w-4xl mx-auto">
          <div className="p-8 rounded-2xl bg-gray-900/40 border border-gray-800/30">
            <h3 className="text-xl font-bold text-white mb-6">
              Important Information
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div>
                <h4 className="text-gold font-semibold text-sm uppercase tracking-wider mb-2">Payment</h4>
                <p className="text-gray-400 text-sm leading-relaxed">
                  Cash payment only. Payment due at time of service. 
                  A deposit may be required for large events.
                </p>
              </div>
              <div>
                <h4 className="text-gold font-semibold text-sm uppercase tracking-wider mb-2">Service Area</h4>
                <p className="text-gray-400 text-sm leading-relaxed">
                  All services within Calgary city limits. Travel fees may apply 
                  for locations outside the city core.
                </p>
              </div>
              <div>
                <h4 className="text-gold font-semibold text-sm uppercase tracking-wider mb-2">VIP Perks</h4>
                <p className="text-gray-400 text-sm leading-relaxed">
                  Complimentary beverage included with all VIP Private Dance bookings.
                  Premium setting with curated ambiance.
                </p>
              </div>
              <div>
                <h4 className="text-gold font-semibold text-sm uppercase tracking-wider mb-2">Custom Events</h4>
                <p className="text-gray-400 text-sm leading-relaxed">
                  Need something specific? We create custom packages for unique occasions.
                  Contact us for a personalized quote.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 px-6 bg-gradient-to-b from-[#0a0a0f] via-purple-950/10 to-[#0a0a0f]">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-4">
            Ready to Book?
          </h2>
          <p className="text-gray-400 mb-6">
            Secure your experience today. Available 24/7.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/book"
              className="px-10 py-4 bg-gold text-black font-bold text-lg rounded-full hover:bg-gold-light transition-all duration-300 shadow-lg shadow-gold/30"
            >
              Book Now
            </Link>
            <a
              href="mailto:booking@exoentertainment.ca"
              className="px-10 py-4 border border-purple-700 text-purple-400 font-bold text-lg rounded-full hover:bg-purple-700 hover:text-white transition-all duration-300"
            >
              Contact Us
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Services;
